<template>
	<div class="wh-block">
		<h3>Большой секрет</h3>
		<div class="rt">
			<div class="rt__buttons">
				<button class="uk-button" @click="connectUserChanel">Connect User Channel</button>
				<button class="uk-button" @click="connectPrivateChanel">Connect Private</button>
				<button class="uk-button" @click="sendPrivateMessage">Send Private</button>
				<button class="uk-button" @click="sendUserMessage">Send User Message</button>
			</div>
			<hr class="uk-hr">
			<div class="rt__chat">
				<h4>Болталка</h4>
				<div class="rt__chatarea">
					<ul class="rt__chatitems" v-if="chats">
						<li class="rt__chatitem" v-for="chat in chats" :key="chat.id">
							<small>{{chat.name }}</small>
							{{ chat.message }}
						</li>
					</ul>
					<textarea class="uk-textarea uk-margin-bottom" placeholder="Введите сообщение" v-model="message"></textarea>
					<button class="uk-button uk-button-primary" @click="sendMessage">Отправить</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
  import { mapGetters } from 'vuex'
  export default {
    name: "rtime",
    data() {
      return {
        chats: [],
        status: '',
        message: '',
      }
    },
    props: {
      items: ''
    },
    watch: {
      ...mapGetters({
        user: 'user'
      }),
      client: function () {
        this.connect();
      }
    },
    inject: ['http'],
    computed: {
      client() {
        return this.$root.client;
      }
    },
    methods: {
      async sendMessage() {
        let message = this.message;
        let name = this.user.name;
        let data = {
          'message': message,
          'name': name
        }
        let result = await this.http.post('onSendMainChatMessage', data).then(function (res) {
          //console.log(res);
        });
      },
      async sendPrivateMessage(){
        let message = 'Private Message';
        let name = this.user.name;
        let data = {
          'message': message,
          'name': name
        }
        let result = await this.http.post('onSendPrivateMessage', data).then(res => res.data)
      },
      async sendUserMessage(){
        let name = this.user.name;
        let id = this.user.id;
        let message = 'Сообщение для пользователя ' + name;
        let data = {
          'message': message,
          'name': name,
          'id': id
        }
        let result = await this.http.post('onSendUserMessage', data).then(res => res.data)
      },
      presence() {
        subscription.presence().then(function (message) {
          // presence data received
        }, function (err) {
          // presence call failed with error
        });
      },
      history() {
        subscription.history().then(function (message) {
          // history messages received
        }, function (err) {
          // history call failed with error
        });
      },
	    publish(){
        subscription.publish({"input": "hello world"}).then(function() {
          // success ack from Centrifugo received
        }, function(err) {
          // publish call failed with error
        });
	    },
	    connectPrivateChanel(){
        let app = this;
        console.log('connect privete channel');
        let client = this.client;
        client.subscribe('$private', function(message) {
          app.chats.push(message.data);
          console.log(message);
        }).on("subscribe", function (e) {
          console.log(e);
        }).on("error", function (e) {
          console.log(e);
        });
	    },
      connectUserChanel(){
        let app = this;
        let id = this.user.id;
        console.log('connect user channel');
        let client = this.client;
        client.subscribe('user#15,16', function(message) {
        //client.subscribe('user#' + id, function(message) {
          app.chats.push(message.data);
          console.log(message);
        }).on("subscribe", function (e) {
          console.log(e);
        }).on("error", function (e) {
          console.log(e);
        });
      },
      connect() {
        let client = this.client;
        if (client) {
          let app = this;
          client.subscribe("public:chat", function (message) {
            console.log(message);
            app.chats.push(message.data);
            app.message = '';
          }).on("subscribe", function (e) {
            console.log(e);
          });
          ;
        }
      }
    },
    mounted() {
      this.connect();
    }
  }
</script>